import { SeuFileType } from '@seu-types';

export function getFileSpecifierFromFileType(type: SeuFileType): string | null {
  switch (type) {
    case 'pdf':
      return '.pdf';
    case 'docx':
      return '.docx';
    case 'xlsx':
      return '.xlsx';
    case 'xlsm':
      return '.xlsm';
    case 'vsdx':
      return '.vsdx';
    case 'msg':
      return '.msg';
    case 'eml':
      return '.eml';
    default:
      return null;
  }
}

export function getMimeTypeFromFileType(type: SeuFileType): string {
  switch (type) {
    case 'pdf':
      return 'PDF';
    case 'docx':
      return 'Word';
    case 'xlsx':
      return 'Excel';
    case 'xlsm':
      return 'Excel';
    case 'vsdx':
      return 'Visio';
    case 'msg':
      return 'Outlook';
    case 'eml':
      return 'Email';
  }
}
